/* eslint-disable react/static-property-placement */
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import cx from 'classnames';

import s from './CountrySelection.css'; // eslint-disable-line css-modules/no-unused-class

const messages = defineMessages({
  selectYourCountry: {
    id: 'countrySelection.selectYourCountry',
    defaultMessage: '##Select your document##',
    description: 'Header text for selecting document list',
  },
});

class CountrySelection extends React.Component {
  static propTypes = {
    locations: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ).isRequired,
    onSelectedCountry: PropTypes.func.isRequired,
  };

  static contextTypes = {
    intl: intlShape,
  };

  constructor(props) {
    super(props);
    this.state = { selectedCountry: props.locations[0] };
  }

  onClick(country) {
    this.props.onSelectedCountry(country);
    this.setState({ selectedCountry: country });
  }

  render() {
    const { locations } = this.props;
    const { selectedCountry } = this.state;
    const { locale } = this.context.intl;
    return (
      <div className={cx(s.root, s[locale])}>
        <h2>
          <FormattedMessage {...messages.selectYourCountry} />
        </h2>
        <ul>
          {locations.map(country => (
            <li key={country.id}>
              <button
                className={cx(
                  selectedCountry &&
                    selectedCountry.id === country.id &&
                    s.selected,
                )}
                onClick={() => {
                  this.onClick(country);
                }}
              >
                {country.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(CountrySelection);
